import { Type } from '@angular/core';

export interface ComposableInputComponentBlock {
  component: Type<object>;
  data?: Record<string, unknown>;
}

export interface ComposableInputFocusEvent {
  messageOffset: number;
  messageContent: string;
  index: number;
}

/**
 * Represents a single message segment: either editable text or a component block.
 */
export type ComposableInputMessage = string | ComposableInputComponentBlock;

export enum KeyboardKey {
  Enter = 'Enter',
  Escape = 'Escape',
  Tab = 'Tab',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  Backspace = 'Backspace',
  Delete = 'Delete',
  Home = 'Home',
  End = 'End',
  PageUp = 'PageUp',
  PageDown = 'PageDown',
  Space = ' ',
  Shift = 'Shift',
  Control = 'Control',
  Alt = 'Alt',
  Meta = 'Meta'
}
